import pxToRem from 'assets/theme/function/px-to-rem';

const tableContainer = {
    styleOverrides: {
        root: {
            '.MuiTableCell-body': {
                textAlign: 'center',
                backgroundColor: 'transparent',
            },
            borderRadius: `${pxToRem(14)} ${pxToRem(14)} ${pxToRem(0)} ${pxToRem(0)}`,
        },
    },
};

export default tableContainer;
